import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_bath: FaireCategoryEntity = {
  token: "cat_home-decor-bath",
  type: "category",
  name: "Bath",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/bath",
  childCategoryTokens: [
    "cat_bath-all",
    "cat_bath-accessories",
    "cat_bath-decor",
    "cat_bath-mats",
    "cat_bath-shower",
    "cat_bath-towels",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
